// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"218":"f675c05e","242":"5e0d3d0e","255":"db5f5a6b","291":"35d612f9","453":"3652d155","665":"7a470c64","755":"87e199fd","828":"1109e799","839":"d27dd7cc","916":"e2785b73"}[chunkId] + ".chunk.js";
};